import { api } from "@/lib/api";
import type { User } from "./use-auth";

type UpdateProfileRequest = {
  first_name?: string;
  last_name?: string;
  email?: string;
  title?: string;
  bio?: string;
};

export function useUpdateProfile() {
  return api.usePatch<User, UpdateProfileRequest>("/api/auth/user/");
}
